import * as holidayTypesApi from '@/api/holidayTypes/holidayTypes'

const holidayTypes = {
  state: {
  },
  mutations: {
  },
  actions: {
    getHolidayTypes ({ commit }, data) {
      return new Promise((resolve, reject) => {
        holidayTypesApi.getHolidayTypes(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },

  }
}

export default holidayTypes
